// 默认开启提示
let needTip = true;

const extractNewScripts = (baseUrl) => new Promise(resolve => {
  // 创建XMLHttpRequest对象
  const xhr = new XMLHttpRequest();
  // 指定请求的类型和URL
  xhr.open('GET', `/${baseUrl}/_version.json?_timestamp=${Date.now()}`, true);
  // 设置回调函数来处理请求的状态变化
  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      // eslint-disable-next-line no-magic-numbers
      if (xhr.status === 200 && xhr.responseText) {
        // 请求成功，处理返回的数据
        console.log('version', xhr.responseText)
        resolve(JSON.parse(xhr.responseText));
      } else {
        resolve(null);
      }
    }
  };
  // 发送请求
  xhr.send();
});

const needUpdate = async (baseUrl) => {
  const versionJson = await extractNewScripts(baseUrl);
  console.log('version', versionJson)
  if (!versionJson) {
    return false;
  }
  return versionJson.commitId !== process.env.commitId;
};

const DURATION = 10000;

const extFn = async (baseUrl, cb) => {
  const willUpdate = await needUpdate(baseUrl);
  console.log('version', willUpdate, needTip)
  if (willUpdate && needTip) {
    // 延时更新，防止部署未完成用户就刷新空白
    cb && cb();
    // 关闭更新提示，防止重复提醒
    needTip = false;
  }
  return needTip;
};

let timer = null;

const timeOut = (baseUrl, cb) => {
  timer = setTimeout(async () => {
    window.clearTimeout(timer);
    timer = null;
    const result = await extFn(baseUrl, cb);
    if (result) {
      timeOut(baseUrl, cb);
    }
  }, DURATION);
};

export const autoRefresh = (baseUrl, cb) => {
  // timeOut(baseUrl, cb);
  document.addEventListener('visibilitychange', async () => {
    console.log('version', document.hidden, needTip)
    if (!document.hidden && needTip) {
      await extFn(baseUrl, cb);
    }
  });
};
